import React from 'react';
import {
  Container,
  TextArea,
  SnippetNameContainer,
  SnippetFormControls,
  DeleteIcon,
  CheckIcon,
  EditIcon,
} from './style';
import { isClickedOnElementWithId } from 'components/pspdf/components/helpers';
import { useTranslation } from 'i18n';

export interface SnippetNameFormProps {
  value: string;
  parentNode: HTMLDivElement;
  hideForm: Function;
  onTextSnippetSave: Function;
  onTextSnippetDelete: Function;
  selection: any;
}

const defaultProps = {
  value: '',
};

export const snippetFormId = 'Cortlex-Name-Editor';

export const nameSnippetFormButtonIds = {
  delete: 'Cortlex-Name-Editor-Delete',
  save: 'Cortlex-Name-Editor-Save',
  edit: 'Cortlex-Name-Editor-Open',
};

function SnippetNameForm({
  selection,
  parentNode,
  hideForm,
  onTextSnippetDelete,
  onTextSnippetSave,
  value,
}: SnippetNameFormProps) {
  parentNode.addEventListener('click', handleSnippetFormClick);

  let textArea = parentNode.querySelector('textarea');
  const { t } = useTranslation();

  setTimeout(() => {
    textArea = parentNode.querySelector('textarea');
    textArea?.focus();
  }, 100);

  function handleSnippetFormClick(event) {
    if (isClickOnSaveButton(event)) {
      return handleSave();
    }

    if (isClickOnDeleteButton(event)) {
      return handleDelete();
    }
  }

  function handleSave() {
    if (textArea?.value) {
      selection
        .saveAnnotation({ name: textArea.value, isNamed: true })
        .then(() => {
          onTextSnippetSave(selection.getCustomData());

          hideForm();
        });
    }
  }

  async function handleDelete() {
    if (selection.getCustomData('name')) {
      await selection.saveAnnotation({ name: '', isNamed: false });

      onTextSnippetDelete(selection.getCustomData());

      if (selection.shouldDeleteAnnotation()) {
        selection.deleteAnnotation();
      }
    }

    hideForm();
  }

  return (
    <Container id={snippetFormId}>
      <SnippetFormControls>
        <DeleteIcon id={nameSnippetFormButtonIds.delete} />
        <CheckIcon id={nameSnippetFormButtonIds.save} />

        <TextArea
          value={value}
          onChange={() => undefined}
          placeholder={t('Enter snippet name')}
          required
        />
      </SnippetFormControls>
    </Container>
  );
}

SnippetNameForm.defaultProps = defaultProps;

export function SnippetName({ name = 'name', offset }) {
  return (
    <Container id={snippetFormId} offset={offset}>
      <SnippetFormControls $preview>
        <EditIcon id={nameSnippetFormButtonIds.edit} />
      </SnippetFormControls>
      <SnippetNameContainer>{name}</SnippetNameContainer>
    </Container>
  );
}

function isClickOnSaveButton(event: any) {
  return isClickedOnElementWithId(event, nameSnippetFormButtonIds.save);
}

function isClickOnDeleteButton(event: any) {
  return isClickedOnElementWithId(event, nameSnippetFormButtonIds.delete);
}

export default SnippetNameForm;
